import type { FaireProductEntity } from "../../entity_types/product";

export const p_9wcxnbn23v: FaireProductEntity = {
  token: "p_9wcxnbn23v",
  type: "product",
  name: "Natural Stone Semi-Precious Glass Mixed Necklace | 40NK9659",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/65783cbae471e3ffad3519b73d458f8824c1447e0e0cb5b896b97adb28797e89.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e5f37210d16dff29b06bee95d95d76b69a0574d5b53bbf6544fa1a9c8ab9576e.jpeg",
    "https://cdn.faire.com/fastly/e720bbe9b90878021ec354958481c005e7049262e94d779d1efa23d24fe66093.jpeg",
    "https://cdn.faire.com/fastly/32951f22edba9cbeece560749619a31e02a1bb6d1716fe3cb1964f07ccdf563c.jpeg",
    "https://cdn.faire.com/fastly/dc3bc68e4a97d628558c67b020c69917131d03192dae099fe2b87c43bb6ff937.jpeg",
  ],
  priceDollars: 5.95,
  description:
    'Natural Stone Semi Precious glass  Mixed colored Necklace is a beautifully crafted piece featuring a blend of natural stones with glass stone.  This elegant combination offers a balance of organic charm and modern durability, making it perfect for everyday wear or layering with other favorites. \n\nProduct Details:\nlength:  18"\nclasp: charm spring clasp\nmetal finish:  Glass\nmaterial:  Copper\nproduct: Lead & Nickel Compliant\ndurability: Tarnish Free, Non-Tarnish\n\nNatural Stone Necklace |  semi precious stone necklace |  beaded necklace |  New Color Necklace | Classic necklace |  natural necklace |  handmade |  colorful ',
  tags: [],
  msrpDollars: 11.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:52.141Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
